module.exports = __webpack_public_path__ + "static/img/lb.ac1828d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lb.png
// module id = XqWh
// module chunks = 1